import i18n from '@i18n'

export type ErrorKeys =
    | 'SITE_NOT_FOUND_ERROR_MESSAGE'
    | 'CHECK_INTERNET_CONNECTION'
    | 'DEFAULT'
    | 'SMS_NOT_SENT_ERROR_MESSAGE'
    | 'E001_SITE_NOT_LIVE'
    | 'E002_SITE_NOT_CONFIGURED'

// Map next errors from the backend
export const errorCodeMapper: { [key in ErrorKeys]: string } = {
    SITE_NOT_FOUND_ERROR_MESSAGE: 'siteNotFound',
    CHECK_INTERNET_CONNECTION: 'checkInternetConnection',
    SMS_NOT_SENT_ERROR_MESSAGE: 'smsNotSent',
    DEFAULT: 'default',
    E001_SITE_NOT_LIVE: 'siteNotLive',
    E002_SITE_NOT_CONFIGURED: 'siteNotLive'
}

export const getErrorLinkByErrorMessage = (errorMessage: string) => {
    const errorMessageObject = JSON.parse(errorMessage)

    const errorCode = errorMessageObject?.errorCode

    return errorCode ? `/error?errorCode=${errorCode}` : '/error'
}
